import React from 'react';
import { withNamespaces } from 'react-i18next';
import { Redirect } from 'react-router-dom';
import storage from 'store';

import { INTERNAL_LINKS } from '../../enum';
import { getRedirectUri } from '../../utils/auth';
import SentryRoute from '../SentryRoute';
import Toast from '../Toast';

const PrivateRoute = props => {
  const { t, path, component: Component, render, ...rest } = props;

  return (
    <SentryRoute
      {...rest}
      path={path}
      render={routeProps => {
        if (!storage.get('accessToken')) {
          Toast({
            type: 'error',
            message: t('mustBeLoggedInToAccess'),
          });

          return <Redirect to={`${INTERNAL_LINKS.LOGIN}?redirect_uri=${getRedirectUri()}`} />;
        }

        if (typeof render === 'function') {
          return render(routeProps);
        }

        return <Component {...routeProps} />;
      }}
    />
  );
};

export default withNamespaces()(PrivateRoute);
